<form [formGroup]="accessoryForm" (submit)="submit()">
  @if (accessoryForm) {
    <app-equipment-identification
      [equipmentVariant]="EquipmentVariant.Accessory"
      (fetchingProductData)="isFetchingProductData = $event"
    />
    <div>
      <p class="control-group-title">Betalingsmetode</p>
      <app-accessory-payment-details />
    </div>
    <app-equipment-voice-number-type
      [equipmentPaymentType]="paymentMethodControl?.value"
      [isSubscriptionLimitReached]="isSubscriptionLimitReached()"
      [voiceProductsAvailableForUpgrade]="unchangedVoiceSubscriptions()"
    />
  }

  <app-ice-button
    color="primary"
    testId="manual-registration-accessories-submit-button"
    type="submit"
    [disabled]="!accessoryForm?.valid || isFetchingProductData"
  >
    Fortsett
  </app-ice-button>
</form>
